import { useAuth } from '../../shared/context';
import { CompanyTeasersPage } from './CompanyTeasersPage';
import { EmployeeTeasersPage } from './EmployeeTeasersPage';

export const Teasers: React.FC = () => {
	var auth = useAuth();

	return auth.currentUser.isEmployeeUser ? <EmployeeTeasersPage /> : <CompanyTeasersPage />;
};
